import { render, staticRenderFns } from "./TransitionSoundSection.vue?vue&type=template&id=fa85fd00&scoped=true"
import script from "./TransitionSoundSection.vue?vue&type=script&lang=js"
export * from "./TransitionSoundSection.vue?vue&type=script&lang=js"
import style0 from "./TransitionSoundSection.vue?vue&type=style&index=0&id=fa85fd00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa85fd00",
  null
  
)

export default component.exports